export default __webpack_public_path__ + "static/media/Grid interface add plus 3.0b55ba0d.svg";